module.exports = __webpack_public_path__ + "static/img/right-bottom-row-6.6a2dcdcd.webp";